import { useTranslation } from 'react-i18next';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇧🇷' },
    { code: 'ko', name: '한국어', flag: '🇰🇷' },
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className='flex gap-2 items-center'>
      <select
        onChange={(e) => handleLanguageChange(e.target.value)}
        value={i18n.language}
        className='bg-b-surface2 text-t-primary border border-b-outline rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-t-primary transition-all cursor-pointer'
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
